import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SetUpPasswordContainer } from 'src/containers/auth/set-up-password';
import { z } from 'zod';

const resetPasswordSearchSchema = z.object({
  redirectAfterCompleteUrl: z.string().catch('/'),
  token: z.string(),
});

export const Route = createFileRoute('/(common)/set-up-password')({
  component: SetUpPasswordContainer,
  validateSearch: zodValidator(resetPasswordSearchSchema),
});
